export enum BtnMode {
    PRIMARY = 'primary',
    PRIMARYSMALL = 'primarySmall',
    PRIMARYBIG = 'primaryBig',
    SECONDARY = 'secondary',
    SECONDARYBIG = 'secondaryBig',
    CANCEL = 'cancel',
    DARK = 'dark',
}